// extracted by mini-css-extract-plugin
export default {"container":"ysd9ih"};